import { Pipe, PipeTransform } from '@angular/core';
import { RenderPreview } from './buyer-preview.models';

@Pipe({
    name: 'doesHiddenInputExist',
    standalone: true,
})
export class DoesHiddenInputExistPipe implements PipeTransform {
  transform(qnObj: RenderPreview): boolean {
    return qnObj.data.some((fieldItem) => fieldItem.isHidden);
  }
}
